import { render, staticRenderFns } from "./InvitePatientButtons.vue?vue&type=template&id=cc6e882e&scoped=true"
import script from "./InvitePatientButtons.vue?vue&type=script&lang=js"
export * from "./InvitePatientButtons.vue?vue&type=script&lang=js"
import style0 from "./InvitePatientButtons.vue?vue&type=style&index=0&id=cc6e882e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6e882e",
  null
  
)

export default component.exports